export default __webpack_public_path__ + "static/media/chapters.04c97286.svg";